<div class="detail-page-card">
    <div class="detail-page-card-title">
        Holidays and Days off
        <cerrix-instructions-icon
            [instructionText]="
                'The holidays and other days off can be used in planning of series of activities in combination with the standard working days'
            "
            [showText]="false"
        ></cerrix-instructions-icon>
    </div>
    <div class="detail-page-card-body padded form-group-styling cerrix-control-sm">
        <cerrix-button
            buttonType="primary"
            primaryColor="blue"
            buttonSize="medium"
            (click)="openAddHolidayDialog()"
            ><i class="fa-solid fa-plus"></i> Add</cerrix-button
        >
        <cerrix-input
            placeholder="Search..."
            [(value)]="searchValue"
            (valueChange)="updateList()"
        ></cerrix-input>
        <div class="holidays-daysoff-list">
            @for (year of filteredList; track year.year) {
                <div class="holidays-daysoff-year-group">
                    <div class="holidays-daysoff-year-group-title">
                        {{ year.year }}
                    </div>
                    <div class="holidays-daysoff-items">
                        @for (item of year.holidays; track item.name) {
                            <div
                                class="holidays-daysoff-item"
                                (click)="openEditHolidayDialog(item)"
                            >
                                <div class="holidays-daysoff-item-name">
                                    {{ item.name }}
                                </div>
                                <div class="holidays-daysoff-item-date">
                                    {{ item.date | dateTimeFormat: false : false }}
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    </div>
</div>

<ng-template #addDialog>
    <div class="add-days-dialog">
        <div class="add-days-dialog-header">
            <h2>Holidays and Days off</h2>
            <i class="fa-regular fa-xmark-large" (click)="closeDialog()"></i>
        </div>
        <div class="add-days-dialog-body">
            <div class="entry-group">
                <label for="dayname">Name</label>
                <cerrix-input
                    [name]="'dayname'"
                    [placeholder]="'Enter name'"
                    [(value)]="dialogDayName"
                ></cerrix-input>
            </div>
            <div class="entry-group">
                <label for="daydate">Date</label>
                <cerrix-input
                    [type]="'date'"
                    [name]="'daydate'"
                    [(value)]="dialogDayDate"
                ></cerrix-input>
            </div>
        </div>
        <div class="add-days-dialog-footer">
            <div class="actions-left">
                @if (editingDay) {
                    <cerrix-button
                        buttonType="primary"
                        primaryColor="red"
                        buttonSize="medium"
                        (click)="deleteHoliday(editingDay)"
                        >Delete</cerrix-button
                    >
                }
            </div>
            <div class="actions-right">
                <cerrix-button
                    buttonType="secondary"
                    secondaryColor="filled"
                    buttonSize="medium"
                    (click)="closeDialog()"
                    >Cancel</cerrix-button
                >
                <cerrix-button
                    buttonType="primary"
                    primaryColor="green"
                    buttonSize="medium"
                    [disabled]="!dialogDayName || !dialogDayDate"
                    (click)="saveHoliday()"
                    >Save</cerrix-button
                >
            </div>
        </div>
    </div>
</ng-template>
